// extracted by mini-css-extract-plugin
export default {"seasons":"SeasonDetails-seasons-GzSX4","truncated":"SeasonDetails-truncated-G6zRV"};